import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import CoursesPage from "./pages/CoursesPage";
import AdmissionsPage from "./pages/AdmissionsPage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import GalleryPage from "./pages/GalleryPage";
import AdminDashboard from "./pages/AdminDashboard";
import ApplyPage from "./pages/ApplyPage";
import OpportunitiesPage from "./pages/OpportunitiesPage";

function App() {
  return (
    <Routes>
      {/* Public landing site */}
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="courses" element={<CoursesPage />} />
        <Route path="admissions" element={<AdmissionsPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="gallery" element={<GalleryPage />} />
        <Route path="apply" element={<ApplyPage />} />
        <Route path="opportunities" element={<OpportunitiesPage />} />
        <Route path="login" element={<LoginPage />} />
      </Route>

      {/* webAdmin only – no Layout (full-screen dashboard) */}
      <Route
        path="admin-dashboard"
        element={
          <ProtectedRoute allowedRoles={["webAdmin"]}>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Home />} />
    </Routes>
  );
}

export default App;
